// import { routes } from '../../../helpers/routes.helper';

export default function PrivacyTerm() {
	return (
		<div className={'bg-accent min-h-12 p-4 flex items-center'}>
			<div className={'w-full flex justify-center'}>
				<p className={'roboto font-semibold text-sm'}>
					© 2024 FAST - Todos os direitos reservados.
					{/*Ao continuar navegando você concorda com a*/}
					{/*nossa <a className={'underline'} href={routes.privacyPolicies}>política de privacidade</a>.*/}
				</p>
			</div>
		</div>
	);
}